import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useDispatch } from 'react-redux';
import { AxiosError } from 'axios';
import { authApiClient } from '../../../utils/axios';
import { showSnackbar } from '../../../api/snackbarSlice';
export const updateUser = async ({ userId, name, email, role_ids = [] }) => {
  const { data } = await authApiClient.put(`/users/${userId}`, { name, email, role_ids });
  return data;
};

export const useUpdateUserHandler = ({ onSuccess } = {}) => {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: updateUser,
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: ['auth-users'] });
      dispatch(
        showSnackbar({
          message: 'User updated successfully',
          severity: 'success',
        }),
      );
      onSuccess?.(data);
    },
    onError: (error) => {
      const message =
        error instanceof AxiosError
          ? error.response?.data?.errors?.message || error.message
          : 'Failed to update user';
      dispatch(showSnackbar({ message, severity: 'error' }));
    },
  });

  return {
    mutate: mutation.mutate,
    isPending: mutation.isPending,
  };
};
